import { HttpRequest, HttpResponse } from '@angular/common/http';

export interface RequestCacheEntry {
  url: string;
  response: HttpResponse<any>;
  lastRead: number;
}

const maxAge = 30000; // maximum cache age (ms)

export abstract class CacheRequestServiceBase {

  private cache = new Map<string, RequestCacheEntry>();

  constructor() { }

  abstract isCachable(req: HttpRequest<any>): boolean;

  get(req: HttpRequest<any>): HttpResponse<any> | undefined {
    const url = req.urlWithParams;
    const cached = this.cache.get(url);

    if (!cached) {
      return undefined;
    }

    return cached.lastRead < (Date.now() - maxAge) ? undefined : cached.response;
  }

  put(req: HttpRequest<any>, response: HttpResponse<any>): void {
    const url = req.urlWithParams;

    const entry = { url, response, lastRead: Date.now() };
    this.cache.set(url, entry);

    // remove expired cache entries
    const expired = Date.now() - maxAge;
    this.cache.forEach(е => {
      if (е.lastRead < expired) {
        this.cache.delete(е.url);
      }
    });
  }
}
